import type { EnvironmentProviders } from '@angular/core';
import {
  AutoRefreshTokenService,
  createInterceptorCondition,
  INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
  type IncludeBearerTokenCondition,
  provideKeycloak,
  UserActivityService,
  withAutoRefreshToken,
} from 'keycloak-angular';
import { environment } from '../environments/environment';

/**
 * Configuration of URLs that will receive the Bearer token
 * Matches all STEF Connect environments and localhost for dev
 */
const includeBearerTokenCondition = createInterceptorCondition<IncludeBearerTokenCondition>({
  urlPattern:
    /^(?:https:\/\/(?:b\.)?stefconnect(?:-dev|-qua)?\.stef\.com\/api|http:\/\/localhost:8080)/i,
  bearerPrefix: 'Bearer',
});

/**
 * Keycloak configuration for the application
 * Integrates SSO with IDP routing via idpHint parameter
 */
export const provideKeycloakConfig = (): EnvironmentProviders =>
  provideKeycloak({
    config: {
      url: environment.keycloak.url,
      realm: environment.keycloak.realm,
      clientId: environment.keycloak.clientId,
    },
    initOptions: {
      onLoad: 'check-sso',
      useNonce: true,
      enableLogging: true,
      scope: 'openid profile email',
      pkceMethod: 'S256',
      flow: 'standard',
      silentCheckSsoRedirectUri: `${globalThis.location.origin}/silent-check-sso.html`,
      redirectUri: globalThis.location.href,
      checkLoginIframe: false,
    },
    features: [
      withAutoRefreshToken({
        onInactivityTimeout: 'login',
      }),
    ],
    providers: [
      AutoRefreshTokenService,
      UserActivityService,
      {
        provide: INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
        useValue: [includeBearerTokenCondition],
      },
    ],
  });
